module.exports = __webpack_public_path__ + "img/trailer.a507c6ea.png";